import { Toaster as Sonner, type ToasterProps } from "sonner";
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon
} from "lucide-react";

import { useOptionalTheme } from "@/features/theme";

const Toaster = ({ ...props }: ToasterProps) => {
  // Follows the app theme; falls back to light when mounted without a
  // ThemeProvider (component tests render ChakraProvider on its own).
  const resolvedTheme = useOptionalTheme()?.resolvedTheme ?? "light";
  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />
      }}
      style={
        {
          "--normal-bg": "var(--elevated)",
          "--normal-text": "var(--fg)",
          "--normal-border": "var(--line-3)",
          "--border-radius": "var(--radius-lg)"
        } as React.CSSProperties
      }
      toastOptions={{
        closeButtonAriaLabel: "Dismiss",
        classNames: {
          toast: "cn-toast text-base! shadow-popover!",
          description: "text-fg-3!",
          closeButton:
            "text-fg-3! hover:text-fg! focus-visible:ring-2! focus-visible:ring-primary/40!"
        }
      }}
      {...props}
    />
  );
};

export { Toaster };
